export type EventCallback = (data?: any) => void;

interface EventMap {
  logout: EventCallback[];
  [key: string]: EventCallback[];
}

const events: EventMap = {
  logout: [],
};

function onLogout(cb: EventCallback): void {
  events.logout.push(cb);
}

function trigger(e: string, data?: any): void {
  if (events[e]) {
    events[e].forEach((cb) => cb(data));
  }
}

export { onLogout, trigger };
